import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Footer = () => {
  return (
    <footer className="modern-footer">
      <div className="container">
        <div className="footer-content row">
          <div className="footer-title-section col-9 col-md-4">
            <img src={`${process.env.PUBLIC_URL}/images/logo.png`} className="footer-logo" alt="logo" />
            <p>Email: <a href="mailto:presidente@vivitirrenia.it">presidente@vivitirrenia.it</a></p>
          </div>
          <div className="footer-social-section col-3 col-md-4">
            <h3>Social</h3>
            <div className="social-icons">
              <a href="https://www.facebook.com/vivitirrenia" className="social-icon" target="_blank"><FontAwesomeIcon icon={['fab', 'facebook-f']} /></a>
              <a href="https://www.instagram.com/vivitirrenia" className="social-icon" target="_blank"><FontAwesomeIcon icon={['fab', 'instagram']} /></a>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <small>&copy; 2024 vivi Tirrenia aps. Tutti i diritti riservati.</small>
        </div>
      </div>
    </footer>
  );
};

export default Footer;